export default __webpack_public_path__ + "static/media/IsoCertificate.d9610b05.webp";